import React from "react";
import ExportExcel from "../../Common/ExportExcel";
import { havePermission } from "../../../permissions";
import MARKER_PERMISSIONS from "../../../permissions/Markers.json";
export const DownloadRouteData = ({ disable, getRoutesData }) => {
	if (!havePermission(MARKER_PERMISSIONS.BUTTON_ROUTE_DATA_DOWNLOAD)) return null;
	return (
		<ExportExcel
			disable={disable}
			getRoutesData={getRoutesData}
			fileName={"Routes Data"}
			buttonName={"Routes Data"}
		/>
	);
};

export default DownloadRouteData;
